// @flow
import React, { Component, Fragment } from 'react';
import Slider from 'react-slick/lib';

import houseImage from '../../../../assets/img/shopping-cart/house.png';
import cardMoneyImage from '../../../../assets/img/shopping-cart/card-money.png';
import cardsBankImage from '../../../../assets/img/shopping-cart/cards-bank.png';
import { Desktop, UntilTablet } from '../../../../utils/responsive';

import style from './CarouselCards.scss';

type Props = {
};

type CarouselItem = {
  text: string;
  image: string;
};

const carouselList = [
  {
    text:
      'Paga con Visa, Mastercard, Amex, PayPal, Bitcoins y depósito o transferencia.',
    image: cardMoneyImage,
  },
  {
    text: 'Paga hasta en 3 cuotas sin intereses con Diners y VISA BBVA',
    image: cardsBankImage,
  },
  {
    text:
      'Tu pedido llegará a tu dirección de entrega en cualquier ciudad del país',
    image: houseImage,
  },
];
export default class CarouselCards extends Component<Props> {

  render() {
    const carouselItems = carouselList.map(
      (element: CarouselItem, index: number) => (
        <div className={style.carouselItem} key={`item-${index}`}>
          <div className={style.contentWrap}>
            <img className={style.itemImage} src={element.image} alt="" />
            <span className={style.itemText}>{element.text}</span>
          </div>
        </div>
      )
    );
  
    const settings = {
      dots: false,
      infinite: true,
      arrows: false,
      draggable: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 8000,
      slidesToShow: 1,
    };

    return (
      <div className={style.carouselWrap}>
        <Desktop>{carouselItems}</Desktop>
        <UntilTablet>
          <Slider {...settings}>{carouselItems}</Slider>
        </UntilTablet>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/components/CarouselCards/CarouselCards.jsx